import React from "react";
import styles from "./ShareCourseViaBottomSheet.module.scss";
import { Image } from "@src/components/Image";
import Modal from "@src/components/UIElements/Modal";
import { useDispatch, useSelector } from "react-redux";
import * as actionCreator from "../../store/actions";
import { useRef } from "react";
import { getAwsAssets } from "@src/utils";
import { directDeepLink } from "@src/common/deepLinks/index.js";
import { useTranslation } from "react-i18next";

const ShareCourseViaBottomSheet = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const state = useSelector(
    (state) => state?.bottomSheetReducer?.showShareContentViaBottomSheet
  );
  const socialLinksForShareable = useSelector(
    (state) => state?.bottomSheetReducer?.socialLinksForShareable
  );
  const socialLinks = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.socialLinks
  );

  const copyTextHandler = () => {
    directDeepLink(
      socialLinksForShareable?.copyUrl
        ? socialLinksForShareable?.copyUrl
        : socialLinks?.copyUrl,
      "UTIL_COPY",
      false
    )();
  };

  return (
    <Modal
      showModal={state}
      handleClose={() => {
        dispatch(actionCreator.showShareContentViaBottomSheetAction(false));
        dispatch(actionCreator.setSocialLinksDataAction({}));
      }}
      header={
        <div className="UpcomingLive__ModalHeader">
          {t(
            "components.bottomSheets.components.shareCourseBottomSheet.shareCourseVia",
            "Share Course Via"
          )}
        </div>
      }
    >
      <div className={styles.ShareCourseViaBottomSheet}>
        <div className={styles.ShareCourseViaBottomSheet__socialIcons}>
          {(socialLinksForShareable?.copyUrl
            ? socialLinksForShareable
            : socialLinks
          )?.links?.map((item, i) => (
            <div
              className={
                styles.ShareCourseViaBottomSheet__socialIcons__singleIcon
              }
              key={`${i}share`}
            >
              <div
                className={
                  styles.ShareCourseViaBottomSheet__socialIcons__singleIcon__image
                }
                onClick={
                  () =>
                    // item.type == "WHATSAPP"
                    //   ? directDeepLink(
                    //       {},
                    //       "UTIL_WHATSAPP",
                    //       false
                    //     )({
                    //       paramOne: item.shareUrl,
                    //       paramTwo: item.shareText,
                    //     })
                    //   :
                    directDeepLink(
                      "",
                      "SOCIAL_LINKS_SHARE",
                      false
                    )({
                      paramOne: item.type,
                      paramTwo: item?.shareUrl,
                      paramThree: item?.shareText,
                    })
                  //// alertitem?.shareUrl)
                }
              >
                <Image
                  src={item.iconUrl}
                  width="30px"
                  height="30px"
                  alt={"icon"}
                />
              </div>
              <p
                className={
                  styles.ShareCourseViaBottomSheet__socialIcons__singleIcon__image__para
                }
              >
                {item.appName}
              </p>
            </div>
          ))}

          <div
            className={
              styles.ShareCourseViaBottomSheet__socialIcons__singleIcon
            }
            onClick={() => {
              directDeepLink(
                {},
                "UTIL_SHARE",
                false
              )({ paramTwo: socialLinks?.moreAppsText });
            }}
          >
            <div
              className={
                styles.ShareCourseViaBottomSheet__socialIcons__singleIcon__image
              }
            >
              <Image
                src={getAwsAssets("moreAppsIcon.svg", "bottomSheets")}
                width="22px"
                height="22px"
                alt={t(
                  "components.bottomSheets.components.shareCourseBottomSheet.moreAppsAlt",
                  "MoreAppsAlt"
                )}
              />
            </div>
            <p
              className={
                styles.ShareCourseViaBottomSheet__socialIcons__singleIcon__image__para
              }
            >
              {t(
                "components.bottomSheets.components.shareCourseBottomSheet.moreApps",
                "More Apps"
              )}
            </p>
          </div>
        </div>
        <p className={styles.ShareCourseViaBottomSheet__divider}>
          {t(
            "components.bottomSheets.components.shareCourseBottomSheet.OR",
            "OR"
          )}
        </p>
        <div className={styles.ShareCourseViaBottomSheet__UrlCopy}>
          <p>
            {socialLinksForShareable?.copyUrl
              ? socialLinksForShareable?.copyUrl
              : socialLinks?.copyUrl}
          </p>
          <div>
            <button onClick={copyTextHandler}>
              {t(
                "components.bottomSheets.components.shareCourseBottomSheet.copy",
                "COPY"
              )}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ShareCourseViaBottomSheet;
